import ScreenOption from "./screen-option";
import CreateButton from "./create-button";

export default class AddNewInline {

	constructor() {
		this.loading = false;
		this.createButton = new CreateButton();
		this.screenOption = null;

		let screenOptionsElement = document.getElementById( 'acp_new_inline_show_button-1' );
		if ( screenOptionsElement ) {
			this.screenOption = new ScreenOption( screenOptionsElement );
		}

		this.initEvents();
	}

	initEvents() {
		if ( this.screenOption && !this.screenOption.isEnabled() ) {
			this.createButton.disable();
		}

		if ( this.screenOption ) {
			this.screenOption.events.addListener( 'changeState', state => {
				state ? this.createButton.enable() : this.createButton.disable();
			} );
		}

		this.createButton.events.addListener( 'click', () => {
			this.addNew();
		} );

	}

	addNew() {
		if ( this.loading ) {
			return;
		}

		this.loading = true;

		jQuery.post( window.location.href, {
			ac_action : 'acp_add_new_inline',
			_ajax_nonce : AC.ajax_nonce,
			list_screen : AC.list_screen,
			layout : AC.layout
		} ).done( ( response ) => {
			if ( response ) {

				if ( response.success && response.data.hasOwnProperty( 'row' ) ) {
					const $row = jQuery( response.data.row );

					jQuery( 'table.wp-list-table tbody' ).prepend( $row );

					// Small animation to draw attention to new row
					$row.hide();
					$row.fadeIn();

					AdminColumns.Table.updateRow( $row[ 0 ] );

					if ( AdminColumns.hasOwnProperty( 'Editing' ) && AdminColumns.Editing.InlineEdit ) {
						AdminColumns.Editing.InlineEdit.initRow( response.data.id );
					}
				}
			}
		} ).always( () => {
			this.loading = false;
		} );
	}

}